import { useCurrency } from '../hooks/useCurrency';
import { DollarSign, Loader2 } from 'lucide-react';

/**
 * Compact currency selector for the global header. Persists to localStorage.
 * Uses cached FX rates from useCurrency context (refreshes hourly server-side).
 */
export default function CurrencySelector({ compact = true }) {
  const { currency, setCurrency, supportedCurrencies, loading } = useCurrency();

  return (
    <div className="flex items-center gap-1.5">
      {loading && <Loader2 className="w-3 h-3 animate-spin text-gray-500" />}
      <select value={currency} onChange={e => setCurrency(e.target.value)}
        className={`bg-dark-700 border border-dark-600 rounded-lg text-white text-xs font-mono cursor-pointer ${compact ? 'px-2 py-1' : 'px-3 py-2'}`}
        title="Display currency — converts USD-denominated values">
        {supportedCurrencies.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
    </div>
  );
}
